import { useNavigate } from "react-router-dom";
import styled from "styled-components";

const EquipmentCard = ({ product }) => {
  const navigate = useNavigate();

  return (
    <TheEquipmentCard onClick={() => navigate(`/equipments/${product.id}`)}>
      <div className="product-image">
        <img src={product.images[0]} alt={product.name} />
      </div>
      <div className="card-footer">
        <h3 className="card-title">{product.name}</h3>
        <span className="card-cta">View Details &rarr;</span>
      </div>
    </TheEquipmentCard>
  );
};

const TheEquipmentCard = styled.div`
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background: #fff;
  cursor: pointer;
  border: 1px solid #e0dbd3;
  transition:
    border-color 0.25s ease,
    box-shadow 0.25s ease;
  font-family: "Georgia", "Times New Roman", serif;

  &:hover {
    border-color: var(--primary-color);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
  }

  .product-image {
    width: 100%;
    height: 160px;
    overflow: hidden;
    background: #f5f2ed;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.5s ease;
    }
  }

  &:hover .product-image img {
    transform: scale(1.04);
  }

  .card-footer {
    padding: 1rem 1.1rem 1.1rem;
    display: flex;
    flex-direction: column;
    gap: 0.6rem;
    border-top: 1px solid #e0dbd3;

    .card-title {
      font-size: 0.92rem;
      font-weight: 400;
      color: #1c1c1c;
      margin: 0;
      line-height: 1.35;
      height:3rem;
    }

    .card-cta {
      font-family: "Courier New", monospace;
      font-size: 0.68rem;
      letter-spacing: 0.13em;
      text-transform: uppercase;
      color: var(--primary-color);
      transition: letter-spacing 0.2s ease;
    }
  }

  &:hover .card-cta {
    letter-spacing: 0.18em;
  }

  /* Responsive */
  @media screen and (max-width: 1366px) {
    .product-image {
      height: 145px;
    }
  }

  @media screen and (max-width: 1200px) {
    .product-image {
      height: 135px;
    }
    .card-footer .card-title {
      font-size: 0.88rem;
    }
  }

  @media screen and (max-width: 900px) {
    .product-image {
      height: 120px;
    }
    .card-footer {
      padding: 0.8rem 0.9rem 0.9rem;
    }
    .card-footer .card-title {
      font-size: 0.85rem;
    }
  }

  @media screen and (max-width: 600px) {
    .product-image {
      height: 105px;
    }
    .card-footer .card-title {
      font-size: 0.8rem;
    }
    .card-footer .card-cta {
      font-size: 0.62rem;
    }
  }

  @media screen and (max-width: 420px) {
    .product-image {
      height: 90px;
    }
    .card-footer .card-title {
      font-size: 0.75rem;
    }
  }

  @media screen and (max-width: 350px) {
    .product-image {
      height: 80px;
    }
    .card-footer .card-title {
      font-size: 0.7rem;
    }
  }
`;

export default EquipmentCard;
